import React from "react";
import { MoviePosterEditor } from "../base/MoviePosterEditor";
import { MISSION_CONFIG } from "./missionConfig";

function MissionPosterEditor(props) {
  return (
    <MoviePosterEditor
      {...props}
      workshopConfig={{
        ...MISSION_CONFIG.poster,
        templateStrings: MISSION_CONFIG.dalle.templateStrings,
        templateElements: MISSION_CONFIG.dalle.templateElements,
      }}
    />
  );
}

export { MissionPosterEditor };
